import { RegisteredCoachScheduleDetail } from '#types/schedule';
import * as S from './styles';

interface RoundProps {
  data: RegisteredCoachScheduleDetail;
}

const Round = ({ data }: RoundProps) => {
  return (
    <S.LabeledInfo>
      <S.LabeledInfoTitle>회차</S.LabeledInfoTitle>
      <S.LabeledInfoDescription>
        {data?.round}/{data?.totalRound}회차
      </S.LabeledInfoDescription>
    </S.LabeledInfo>
  );
};

export default Round;
